import React from "react";
import { FiPlus } from "react-icons/fi";
import Loader from "./Loader";

const NewItemButton: React.FC<{
  onClick?: () => void;
  title: string;
  btnStyle?: string;
  type?: "button" | "submit";
  disabled?: boolean;
  isLoading?: boolean;
  showIcon?: boolean;
}> = ({
  onClick,
  btnStyle,
  title,
  disabled = false,
  isLoading = false,
  type = "button",
  showIcon = true,
}) => {
  return (
    <div className="flex items-center space-x-4">
      <button
        type={type}
        onClick={onClick}
        className={`bg-blue-600 h-10 text-white rounded-lg text-sm 2xl:text-base hover:bg-blue-500 transition w-[7rem] 2xl:w-[8rem] py-2 flex justify-center items-center space-x-2 ${btnStyle} disabled:bg-gray-400 disabled:cursor-not-allowed`}
        disabled={disabled}
      >
        {showIcon && !isLoading && (
          <span>
            <FiPlus className="w-5 h-5" />
          </span>
        )}
        {!isLoading ? <span>{title}</span> : <Loader color="#fff" />}
      </button>
    </div>
  );
};

export default NewItemButton;
